module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/058-myanmar-6f70facb20e57fb46489cd1d56286dd4.svg";